module.exports = __webpack_public_path__ + "img/28.59e7f654.jpg";